<template>
  <div style="overflow: hidden" v-if="visible">
    <force-landscape
      style="background-color: #00000093; z-index: 5"
      :need-force-landscape="needForceLandscape"
    >
      <template>
        <!-- 退出按钮 -->
        <div class="font1">
          <!-- <web-view :src="url" @message="getMessage"></web-view> -->
          <div style="text-align: center; height: 100%; margin-top: 6%">
            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 2vmin;
              "
            >
              <div class="leftarrow"></div>
              <div class="title">{{ config.title }}</div>
              <div class="rightarrow"></div>
            </div>

            <!-- <img :src="imgSrc" id="test" style="width: 63%; height: 100%; display: inline-block" /> -->
            <div class="bg">
              <div
                style="
                  font-size: 16px;
                  margin: auto;
                  'text-align':left ;
                  width: 60%;
                "
              >
                {{ config.content }}
              </div>
            </div>
            <div class="ButtonList">
              <div @click="back()" class="ButtonText2" v-if="config.continue">
                {{ config.continue }}
              </div>
              <div @click="exitgame()" class="ButtonText" v-if="config.exit">
                {{ config.exit }}
              </div>
            </div>
          </div>
        </div>
      </template>
    </force-landscape>
  </div>
</template>
<script>
import ForceLandscape from "../../../components/layout/ForceLandscape.vue";

export default {
  components: {
    ForceLandscape,
  },

  data() {
    return {
      visible: false,
      needForceLandscape: false,
      loaded: false,
      type: 1, // 1残局 2兵海挑战
      modalbefore: {},
      config: {},
    };
  },

  methods: {
    getMessage(value) {
      console.log(value);
    },

    show() {
      this.visible = true;
    },

    back() {
      this.visible = false;
      // this.modalbefore.show();
    },

    exitgame() {
      // window.location.reload();
      // restartGame();
      // CloudGame.pureQuitGame();
      // window.location.replace("/hok/home");
      // router.replace(`/hok/home`);
      this.visible = false;
    },
  },
};
</script>
<style lang="less" scoped>
.font1 {
  font-family: "Radikal Medium";
  height: 100%;
}
.title {
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #fff0bd;
  display: inline-block;
  margin: 0 2vmin;
  text-shadow: 0px 0px 20px rgba(71, 41, 21, 0.77), 0px 0px 5px orange,
    0px 0px 5px orangered, 0px 0px 10px rgba(71, 41, 21, 0.77);
}

.bg {
  background-image: url("../../../assets/hok/dialog_bg.png");
  background-size: 100% 100%;
  width: 100%;
  height: 60%;
  display: flex;
}
.ButtonList {
  // text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 2vmin;
}

.ButtonText {
  color: white;
  display: inline-block;
  margin: 0 2vmin;
  min-width: 35vmin;
  font-size: 15px;
  padding: 2vmin 3vmin;
  background-image: url(../../../assets/hok/anniu1.png);
  background-size: 100% 100%;
}

.ButtonText2 {
  color: white;
  display: inline-block;
  margin: 0 2vmin;
  min-width: 35vmin;
  font-size: 15px;
  padding: 2vmin 3vmin;
  background-image: url(../../../assets/hok/anniu2.png);
  background-size: 100% 100%;
}

.leftarrow {
  background-image: url(../../../assets/hok/huawenzuo.png);
  background-size: 100% 100%;
  display: inline-block;
  width: 22vmin;
  height: 4vmin;
}

.rightarrow {
  background-image: url(../../../assets/hok/huawenyou.png);
  background-size: 100% 100%;
  display: inline-block;
  width: 22vmin;
  height: 4vmin;
}

.exitimg {
  background-image: url(../../../assets/hok/fanhui.png);
  background-size: 100% 100%;
  display: inline-block;
  width: 14vmin;
  height: 8vmin;
}

.exitbutton {
  position: fixed;
  left: 4vmin;
  top: 4vmin;
}

.timetext {
  font-size: 24vmin;
  color: rgb(255, 241, 195);
  margin-top: 10vmin;
}
</style>
